<template>
<v-stepper v-model="e1" class="white" alt-labels>
  <!-- Stepper header -->
  <v-stepper-header class="blue-grey lighten-4 white--text elevation-0">
    <v-stepper-step step="1" :complete="e1 > 1">
      <span><v-icon>search</v-icon>Search targets</span>
    </v-stepper-step>
    <v-divider></v-divider>
    <v-stepper-step step="2" :complete="e1 > 2">
      <span><v-icon class="pb-2">touch_app</v-icon>Select from list</span>
    </v-stepper-step>
  </v-stepper-header>

  <!-- Step 1 Content-->
  <v-stepper-content step="1" id="step-1">
    <div class="text-md-left">
      <v-text-field v-if="disable" disabled class="search-form" name="input-search" label="Search" v-model="search" placeholder="Search targets (example: PARP1, PIK3CA)" :append-icon="'search'"></v-text-field>
      <v-text-field v-if="!disable" class="search-form input-group--focused" name="input-search" v-model="search" min="1" required placeholder="Search targets (example: PARP1, PIK3CA)" @keyup.enter.native="getSearchResults" :rules="[rules.empty()]" :append-icon="'search'"></v-text-field>
      <small>*required field</small>
    </div>
    <v-btn v-if="!search || search.length > 80" class="button-step-1-disabled" disabled flat>Evaluate probes for my target</v-btn>
    <v-btn v-if="search && loading && search.length < 80" class="button-step-1-loading" flat loading>Evaluate probes for my target</v-btn>
    <v-btn v-if="search && !loading && search.length < 80" class="blue-grey darken-3 button-step-1-normal white--text" primary @click.native="getSearchResults">Evaluate probes for my target</v-btn>
  </v-stepper-content>

  <!-- Step 2 Content-->
  <v-stepper-content step="2">
    <div class="text-md-left">
      <v-btn @click.native="e1 = 1" class="grey" outline>
        <v-icon style="margin-left:-12px;">keyboard_arrow_left</v-icon>
        Back
      </v-btn>
      <v-card class="elevation-1 card-list">
        <v-card-title class="white--text blue-grey darken-3" id="step-2">
          <span class="headline">Targets found <span class="body-1">({{searchResultsList.length}} results)</span></span>
          <v-spacer></v-spacer>
          <v-text-field append-icon="search" label="Search" single-line hide-details class="white--text" light v-model="tableSearch" style="color:white !important"></v-text-field>
          <div style="width:100%">Click on the target to explore all the chemical compounds</div>
        </v-card-title>
        <v-card-text class="card-list-text">
          <v-data-table v-bind:headers="tableHeaders" v-bind:pagination.sync="pagination" :items="searchResultsList" v-bind:search="tableSearch" class="elevation-0">
            <template slot="headerCell" scope="props">
              <span v-if="props.header.text !== 'Features'" v-tooltip:bottom="{ html: props.header.tooltip }">
                {{ props.header.text }}
              </span>
              <div v-if="props.header.text === 'Features'">
                Features <v-icon id="features-tooltip" class="features-more">info</v-icon>
              </div>
              <div id="icons-details" v-if="tableFeatures" style="display:none;text-align:left;">
                <div class="tooltip-bold">When the icon is coloured it has the following meaning:</div>
                <table class="icons-table">
                  <tr v-for="(value, key) in tableFeatures" :key="key">
                    <td><img :src="value.imageValid" height="15" width="15" style="background:white;"></td>
                    <td>{{value.textValid}}</td>
                  </tr>
                </table>
              </div>
            </template>
            <template slot="items" scope="props">
                <tr v-on:click="redirectToProbes(props.item.uni)" style="cursor:pointer">
                  <td v-if="search" v-bind:style="{ 'font-weight': props.item.name.toLowerCase() === search.toLowerCase() ? '600' : '300' }">{{ props.item.name }}</td>
                  <td>
                    <div v-for="(value, key) in tableFeatures"
                         style="display:inline"
                         v-tooltip:top="{ html: props.item[key] ? value.textValid : value.textInvalid }">
                      <img
                          :key="key"
                          height="25"
                          width="25"
                          :src="props.item[key] ? value.imageValid : value.imageInvalid"/>
                    </div>
                  </td>
                  <td>{{ props.item.compounds }}</td>
                  <td>{{ props.item.score }}</td>
                </tr>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </div>
  </v-stepper-content>
</v-stepper>
</template>

<script>
import {
  mapGetters
} from 'vuex'

import 'tippy.js/dist/tippy.css'
import tippy from 'tippy.js'
import * as F from '../../constants/Features';

export default {
  props: ['disable'],
  beforeMount() {
    this.tableFeatures = F.FEATURES;
  },
  mounted() {
    tippy('#features-tooltip', {
      html: '#icons-details',
      duration: 1000,
      arrow: true,
      trigger: 'click'
    })
  },
  data() {
    return {
      search: null,
      e1: 1,
      pagination: {},
      emptyRule: true,
      evaluation: null,
      tableFeatures: null,
      tableSearch: '',
      tableHeaders: [{
          text: 'Name',
          align: 'left',
          sortable: true,
          value: 'name',
          tooltip: 'Name of target'
        },
        {
          text: 'Features',
          align: 'left',
          sortable: false,
          value: 'is_suitable_probe',
          tooltip: 'Toggle for more information about the icons'
        },
        {
          text: 'Compounds',
          align: 'left',
          sortable: true,
          value: 'compounds',
          tooltip: 'Number of compounds'
        },
        {
          text: 'Info Richness Score',
          align: 'left',
          sortable: true,
          value: 'score',
          tooltip: 'Information Richness Score'
        }
      ],
      rules: {
        required: (value) => !!value || 'Required.',
        empty: () => !!this.emptyRule || 'No results found'
      }
    }
  },
  computed: mapGetters([
    'searchResultsList', 'loading'
  ]),
  methods: {
    getSearchResults() {
      var that = this;

      that.$store.dispatch("SET_LOADING");

      this.$store.dispatch("GET_SEARCH_RESULTS", that.search).then(function() {
        if (that.searchResultsList.length) {
          that.emptyRule = true;
          that.e1 = 2;
        } else {
          that.emptyRule = false;
        }
        that.$store.dispatch("UNSET_LOADING")
      })
    },
    redirectToProbes(id) {
      this.$router.push('/' + id);
    }
  }
}
</script>

<style scoped>

a {
  text-decoration: none;
}

.search-form {
  width: 100%;
}

.p10 {
  padding: 10px 10px 0 10px;
  background-color: white;
}

.button-step-1-disabled {
  width: 100%;
  color: rgba(0, 0, 0, .2) !important
}

.button-step-1-loading {
  width: 100%;
}

.button-step-1-normal {
  width: 100%;
}

.card-list {
  margin-bottom: 10px;
  padding: 0 !important;
}

.card-list-text {
  padding: 10px 0 0 0 !important;
  border: 1px solid rgba(0, 0, 0, .1);
}

.icons-table {
  width: 100%;
  max-width: 100%;
}

.icons-table td {
  padding: 0 8px !important;
  text-align: left;
}

.features-more {
  font-size: 14px;
  cursor: pointer;
}

.features-more:hover {
  color: #1e88e5;
}

</style>

<style>
.stepper__step--active .stepper__step__step {
  background: #263238 !important;
}

.stepper {
  z-index: 1 !important;
}
.tooltip-bold {
  text-align:left;
  font-weight:600;
  padding:0 0 2px 3px;
}
@media screen and (max-width: 1600px) {
  table.table thead tr {
    height: 20px !important;
  }
}
@media screen and (max-width: 2000px) {
  table.table tbody tr td {
    padding-top: 5px !important;
  }
}
@media screen and (max-width: 1000px) {
  th {
    font-size: 11px !important;
    padding: 5px !important;
    max-width: 30px;
  }
  td {
    font-size: 11px !important;
    padding: 5px !important;
    max-width: 30px;
  }
  th {
    font-size: 11px !important;
    max-width: 40px;
  }
}

#step-1 .input-group--focused label{
  color: #263238 !important;
}
#step-1 .input-group--single-line label{
  color: #263238 !important;
}
#step-1 .input-group__details:after{
  background-color: #263238 !important;
}
#step-1 .input-group .input-group__input .icon {
  color: #263238 !important;
}
#step-2 .input-group--focused label{
  color: white !important;
}
#step-2 .input-group--single-line label{
  color: white !important;
}
#step-2 .input-group__details:after{
  background-color: white !important;
}
#step-2 .input-group .input-group__input .icon {
  color: white !important;
}
#step-2 .input-group input{
  color: white !important;
}

</style>



// WEBPACK FOOTER //
// PrbStepper.vue?5b8f2282